<div class="subheading-container">
  <capra-icon icon="icon-parameters"></capra-icon>
  <h3 class="subheading">Parameters</h3>
</div>
<div *ngFor="let param of params | keyvalue">
  <label class="parameter-label" [attr.data-test]="'parameter-label-' + param.value.name">
    {{ param.value.human_name || param.value.name }}
  </label>
  <capra-icon
    icon="icon-warning"
    class="align-md-icon warning"
    *ngIf="param.value.options_error"
    capraTooltip
    [tooltipContent]="param.value.options_error.message"
    [tooltipPlacement]="bottom"
    tooltip-class="wrapping-tooltip"
  ></capra-icon>
  <mat-select
    *ngIf="param.value.type === 'select' && param.value.options"
    (selectionChange)="onParamChange(param.value.name, $event)"
    [value]="scheduleParams[param.value.name]"
    data-test="single-param-selector"
  >
    <mat-option *ngFor="let opt of param.value.options" [value]="opt[1]" [attr.data-test]="opt[1]">{{
      opt[0]
    }}</mat-option>
  </mat-select>
  <input
    class="form-control"
    type="text"
    *ngIf="param.value.type === 'text' || param.value.type === 'date'"
    [value]="scheduleParams[param.value.name] ?? ''"
    (keyup)="onParamChange(param.value.name, $event)"
    [attr.data-test]="'parameter-text-input-' + param.value.name"
  />
  <mode-select-with-search
    *ngIf="param.value.type === 'multiselect' && param.value.options && !param.value.options_error"
    [fieldType]="param.value.type"
    [defaultOptions]="defaultOptions[param.value.name]"
    (selectedOptionChanged)="multiSelectParameterChanged.emit({ name: param.value.name, value: $event })"
    [attr.data-test]="'parameter-multiselect-' + param.value.name"
  >
  </mode-select-with-search>
  <input
    type="text"
    *ngIf="param.value.options_error"
    [attr.disabled]="true"
    [value]="''"
    class="form-control"
    data-test="param-error"
  />
</div>
